import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, updateEmail, updateProfile } from 'firebase/auth';
import { getFirestore, doc, getDoc, updateDoc } from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import Footer from '../Components/footer';
import Navbar from '../Components/NavBarV2';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';
import './myprofile.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import userAvatar1 from '../images/1.png';
import userAvatar12 from '../images/1.png';
import userAvatar2 from '../images/2.png';
import userAvatar3 from '../images/3.png';
import userAvatar4 from '../images/4.png';
import userAvatar5 from '../images/5.png';
import userAvatar6 from '../images/6.png';
import userAvatar7 from '../images/7.png';
import userAvatar8 from '../images/8.png';


const avatarsMap = {
  userAvatar1: userAvatar1,
  userAvatar2: userAvatar2,
  userAvatar3: userAvatar3,
  userAvatar4: userAvatar4,
  userAvatar5: userAvatar5,
  userAvatar6: userAvatar6,
  userAvatar7: userAvatar7,
  userAvatar8: userAvatar8,
};

// Inicialización de Firestore y Auth
const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);


const MyProfile = () => {
  const [user, setUser] = useState(null);
  const [profileForm, setProfileForm] = useState({
    name: '',
    lastName: '',
    email: '',
    role: '',
    coins: 0,
    cedula: '',
    ruc: '',
    avatar: 'userAvatar1',
  });
  const [isEditing, setIsEditing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState('');
  const [hasChanges, setHasChanges] = useState(false);
  const navigate = useNavigate();
  const avatarsList = Object.keys(avatarsMap);


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDocRef = doc(db, 'usuarios', currentUser.uid);
        const docSnap = await getDoc(userDocRef);

        if (docSnap.exists()) {
          setProfileForm({
            name: docSnap.data().name || '',
            lastName: docSnap.data().lastName || '',
            email: currentUser.email,
            role: docSnap.data().role || '',
            coins: docSnap.data().coins || 0,
            cedula: docSnap.data().cedula || '',
            ruc: docSnap.data().ruc || '',
            avatar: docSnap.data().avatar || 'userAvatar1',
          });
        } else {
          console.log("No such document!");
        }
      } else {
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setProfileForm({ ...profileForm, [id]: value });
    setHasChanges(true);
  };

  const handleAvatarSelect = (avatarName) => {
    setSelectedAvatar(avatarName); // Guardamos el nombre del avatar temporalmente
  };

  const handleSaveAvatar = async () => {
    if (!selectedAvatar) return; // Asegurarse de que se ha seleccionado un avatar

    setProfileForm((prev) => ({ ...prev, avatar: selectedAvatar }));
    if (user) {
      const userDocRef = doc(db, 'usuarios', user.uid);
      await updateDoc(userDocRef, { avatar: selectedAvatar }); // Guardar solo el nombre del avatar
      setIsModalOpen(false); // Cerrar el modal después de guardar
    }
  };


  const getAvatarSrc = (avatarName) => avatarsMap[avatarName] || userAvatar12;

  const handleOpenModal = () => {
    setSelectedAvatar(profileForm.avatar); // Cargar el avatar actual en el modal
    setIsModalOpen(true);
  };

  const handleCloseModal = () => setIsModalOpen(false); // Cierra el modal sin guardar cambios


  const handleSubmit = async (e) => {
    e.preventDefault(); // Evitar envío automático
    if (!hasChanges) {

      return;
    }

    try {
      await updateProfile(user, { displayName: profileForm.name });
      await updateEmail(user, profileForm.email);

      const userDocRef = doc(db, 'usuarios', user.uid);
      await updateDoc(userDocRef, {
        name: profileForm.name,
        lastName: profileForm.lastName,
        email: profileForm.email,
        cedula: profileForm.cedula,
        ruc: profileForm.ruc,
      });
      toast.success("Perfil actualizado exitosamente");
      setIsEditing(false);
      setHasChanges(false); // Resetear cambios
    } catch (error) {
      toast.error("Error al actualizar el perfil.");

      console.log('Error al actualizar el perfil: ' + error.message);
    }
  };

  // Función para iniciar la edición
  const handleEdit = () => {
    setIsEditing(true); // Activar modo de edición
  };

  // Función para cancelar los cambios
  const handleCancel = () => {
    setIsEditing(false); // Desactivar modo de edición
    // Opcional: Restaurar los valores originales si se desea
    setHasChanges(false);
  };


  return (
    <div>
      <Navbar avatar={profileForm.avatar} />
      <ToastContainer />

      <div className="center-header">
        <img className="imagenlateral1" src={Lateral1} alt="Lateral" />
        <div className="Presentation3">
          <div className="profile-title">
            <h2 className="card-title text-2xl font-bold">Mi Perfil</h2>
            <p className="card-description">Administra la información de tu cuenta</p>
          </div>

          <div className='fondo'>

            {/* Formulario debajo del título */}

            <form className="profile-form" onSubmit={handleSubmit}>
              <div className="form-grid">
                {/* Primera columna */}

                    <div className='row'>
                      <img
                        src={getAvatarSrc(profileForm.avatar)} // Obtiene la imagen usando el nombre
                        alt="Avatar"
                        style={{ width: '100px', cursor: 'pointer' }}

                      />

                      <button className="avatar-button" type="button" onClick={handleOpenModal}>Cambiar Avatar</button>
                    </div>
                  <br></br>

                  {/* Modal de selección de avatar */}
                  {isModalOpen && (
                    <div className="avatar-modal">

                      <h3>Selecciona tu Avatar</h3>
                      <div className="avatar-list">
                        {avatarsList.map((avatarName) => (
                          <img
                            key={avatarName}
                            src={avatarsMap[avatarName]} // Mostrar la imagen correspondiente
                            alt={avatarName}
                            style={{
                              width: '80px',
                              cursor: 'pointer',
                              margin: '5px',
                              border: selectedAvatar === avatarName ? '2px solid blue' : '2px solid transparent',
                              borderRadius: '10px',
                            }}
                            onClick={() => handleAvatarSelect(avatarName)} // Guardar el nombre del avatar
                          />
                        ))}
                      </div>

                      <button className="save-button" type="button" onClick={handleSaveAvatar}>Guardar Cambios</button>
                      <button className="close-button" type="button" onClick={handleCloseModal}>Cancelar</button>
                    </div>
                  )}


                  <div className=" floating-label-profile">

                    <input
                      type="text"
                      id="name"
                      value={profileForm.name}
                      onChange={handleChange}
                      disabled={!isEditing}
                      placeholder=''
                    />
                    <label htmlFor="name">Nombre</label>
                  </div>

                  <div className=" floating-label-profile">
                    <input
                      type="text"
                      id="lastName"
                      value={profileForm.lastName}
                      onChange={handleChange}
                      disabled={!isEditing}
                    />
                    <label htmlFor="lastName">Apellido</label>
                  </div>
                  <div className="floating-label-profile">

                    <input
                      type="email"
                      id="email"
                      value={profileForm.email}
                      onChange={handleChange}
                      disabled={!isEditing}
                    />
                    <label htmlFor="email">Correo Electrónico</label>
                  </div>

                  <div className="floating-label-profile">

                    <input
                      type="text"
                      id="cedula"
                      value={profileForm.cedula}
                      onChange={handleChange}
                      disabled={!isEditing}
                    />
                    <label htmlFor="cedula">Cédula</label>
                  </div>

                  <div className="floating-label-profile">

                    <input
                      type="text"
                      id="ruc"
                      value={profileForm.ruc}
                      onChange={handleChange}
                      disabled={!isEditing}
                    />
                    <label htmlFor="ruc">RUC</label>
                  </div>
                  <div className="form-buttons">
                    {isEditing ? (
                      <>
                        <button type="submit">Guardar Cambios</button>
                        <button type="button" onClick={handleCancel}>
                          Cancelar
                        </button>
                      </>
                    ) : (
                      <button type="button" onClick={handleEdit}>
                        Editar Perfil
                      </button>
                    )}
                  </div>

                </div>




              <br></br>
            </form>
          </div>

        </div>
        <img className="imagenlateral2" src={Lateral2} alt="Lateral" />
      </div>
    </div>
  );
};

export default MyProfile;


